import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  duration,
  pxToRem,
  size,
} from '@twistopayments/design-system/styles'

export const list = css`
  padding: 0;
  min-width: 160px;

  li {
    list-style: none;
  }
`

export const name = (theme: Theme) => css`
  color: ${theme.palette.ghost.mediumContrast};
  font-size: ${pxToRem(14)};

  ${breakpoint.up('smMd')} {
    margin-bottom: ${size[16]};
  }
`

export const item = (theme: Theme, hasUnderline?: boolean) => css`
  padding: ${size[12]} 0;

  ${breakpoint.up('smMd')} {
    padding: 0;
    margin-bottom: 10px;
  }

  a span {
    transition: all ${duration.shorter}ms ease-out;
  }

  &:hover {
    a span {
      color: ${theme.palette.primary.mainContrast};
    }

    a {
      text-decoration: ${hasUnderline ? 'underline' : 'none'};
      text-decoration-color: ${theme.palette.primary.mainContrast};
    }
  }
`

export const indent = css`
  margin: 0;

  ${breakpoint.up('smMd')} {
    margin: 0;
  }

  a {
    position: relative;

    span {
      padding-left: ${size[18]};
      margin: 0;
    }

    &::before,
    &::after {
      position: absolute;
      left: 0;
      content: '';
      background-color: rgba(156, 145, 158, 0.36);
    }

    &::before {
      top: calc(50% - 2px);
      height: 2px;
      width: 10px;
    }

    &::after {
      top: 0;
      width: 2px;
      height: 100%;
    }
  }

  &:nth-last-child(2) {
    margin-bottom: 10px;

    a::after {
      height: calc(50% - 2px);
    }
  }
`

export const bold = css`
  a span {
    font-weight: 600;
  }
`
